import React from 'react';
import './LandingPage.css'; // Assuming a CSS file for styling
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import Timeline from './Timeline';

interface LandingPageProps {
  onEnterApp: (view: 'register' | 'search') => void;
}

const LandingPage: React.FC<LandingPageProps> = ({ onEnterApp }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng: string) => {

    i18n.changeLanguage(lng);

  };

  const backgroundStyle: React.CSSProperties = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/football-field.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    color: 'white', // Adjust text color for better contrast
  };

  const CallToAction = <section className="call-to-action">
    <h2>{t('landing.call-to-action')}</h2>
    <div className="button-group">
      <button className="action-button primary" onClick={() => onEnterApp('register')}>{t('wantToPlay')}</button>
      <button className="action-button secondary" onClick={() => onEnterApp('search')}>{t('needPlayers')}</button>
    </div>
  </section>;
  return (
    <div className="landing-page-container" style={backgroundStyle}>
      <Dropdown className="me-2">
        <Dropdown.Toggle variant="outline-light" id="language-dropdown">
          {i18n.language === 'es' ? '🇪🇸 ES' : i18n.language === 'es_AR' ? '🇦🇷 ES' : '🇬🇧 EN'}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => changeLanguage('es_AR')}>🇦🇷 Español</Dropdown.Item>
          <Dropdown.Item onClick={() => changeLanguage('es')}>🇪🇸 Español</Dropdown.Item>
          <Dropdown.Item onClick={() => changeLanguage('en')}>🇬🇧 English</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <header className="landing-header">
        <h1>{t('landing.header')}</h1>
        <p className="tagline">{t('landing.header-tagline')}</p>
        <p className="seo-text">
          ¿Cuantas veces estabas manija de jugar un partidito y no tenias cancha ni equipo?<br />
          ¿Cuantas veces esuchaste ese 'nos falta uno' a media hora del partido?
        </p>
      </header>

      {CallToAction}

      <section className="how-it-works">
        <h2>{t('landing.h2')}</h2>
        <Timeline events={[
          { title: t('landing.step1.head'), description: t('landing.step1.text') },
          { title: t('landing.step2.head'), description: t('landing.step2.text') },
          { title: t('landing.step3.head'), description: t('landing.step3.text') },
        ]} />
      </section>

      {CallToAction}

      <footer className="landing-footer">
        <p>&copy; {t('landing.footer')}</p>
      </footer>
    </div>
  );
};

export default LandingPage;